import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useStaffAccess } from '../hooks/use-staff-access.js';

/** Keeps a staff login off screens their role can't view (typed URL, stale link) — sends them
 *  home, which every portal user can see, so there's no redirect loop. */
export function StaffModuleGate() {
  const { pathname } = useLocation();
  const { canViewPath } = useStaffAccess();
  return canViewPath(pathname) ? <Outlet /> : <Navigate to="/" replace />;
}

/** Staff management is for the store owner only, never their staff. */
export function StoreOwnerGate() {
  const { isStoreOwner } = useStaffAccess();
  return isStoreOwner ? <Outlet /> : <Navigate to="/" replace />;
}
